import styled from 'styled-components'
import { SiteSelectorK8WrapperDark as BaseSiteSelectorK8WrapperDark } from 'components/SiteSelector'

export const SiteSelectorK8WrapperDark = styled(BaseSiteSelectorK8WrapperDark)`
  padding: 0;
`
